import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/logins.template.htm';
import Table from 'text-loader!../templates/logins_table.template.html';
import Collection from '../models/logins.paginated.collection.ts';
import Model from '../models/logins.model.ts';
import 'dhtmlxMessage';
import Pagination from '../views/pagination.view.ts';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import '../../libs/bootstrap/js/bootstrap-table.js';
import i18n  from "l10n";
import popup from 'popup';
import 'jqueryUI';
import TableRowPartialTemplate from 'text-loader!../templates/partial_templates/loginRow.partial.template.html';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	tableRowPartialTemplate: Handlebars.compile(TableRowPartialTemplate),
	progressTemplate: Handlebars.compile("{{> progressPartial}}"),
	table: Handlebars.compile(Table),
	superInitialize: GenericView.prototype.initialize,
	collection: null,
	model: null,
	isFirstDisplay: true,
	lastSearchedText: "",
	initialize: function () {
		var self = this;

		this.collection = new Collection();
		this.collection.state.pageSize = 999;
		this.collection.on( 'sync', this.successData, this );
		this.collection.on( 'error', this.errorData, this );

		this.collection.url = 'rest/api/admin/logins';
		this.collection.getFirstPage();
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;
		this.$el.html(this.template());
	},
	events: {
	    "click .venueAccordion": "loadDataFor",
	    "click .logout-user-action": "logoutSpecificUser",
        //"keyup #search": "search"
	},
	/*search: function(event)
	{
		element = $(event.currentTarget);
		var text = element.val().trim();

        if(this.lastSearchedText != text )
        {
			$.ajaxq.abort("DefaultQueue");
			this.lastSearchedText = text;
			this.collection.url = 'rest/api/users?q=' + encodeURIComponent("lastname="+element.val().trim());
			this.collection.getFirstPage();
		}
	},*/
	successData: function()
	{
		var self = this;
		self.hideActionProgressBar();

		if(this.isFirstDisplay)
		{
			this.isFirstDisplay = false;
			this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
		}

		$('#table-container').html(this.table({ "orgs" : this.collection.models, pageInfo : this.collection.info()}));

		this.pagination = new Pagination({ collection : this.collection });
		this.pagination.render();
		$( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

		if(this.collection.models.length > 0)
		{
			$('#table-container').show();

			// if it has only one page
			if(this.collection.state.firstPage == this.collection.state.lastPage)
			    $('#pagination').hide();
			else
			    $('#pagination').show();
			$('#empty').hide();

            //self.initializeTrs(this.showHideActionButton, "#dataTables");
		}
		else
		{
			$('#table-container').hide();
			$('#pagination').hide();
			$('#empty').show();
		}

		this.$el.find(".accordion").accordion({
		    collapsible: true,
		    active: false
		});
	},
	errorData: function(collection, xhr, options)
	{
 		this.onErrorHandler(collection, xhr, options);
	},
	loadDataFor: function(e) {
	    const self = this;
	    const $elem = $(e.currentTarget);

        if(!$elem.hasClass("ui-accordion-header-active")) // closing the accordion
            return;

        const $container = $($elem.parent().find(".loginsContainer")[0]);
	    var venueId = $elem.data("venue");

        $container.empty();

        var tr = $("<tr/>");
        tr.css("display", "block");
        tr.html(self.progressTemplate());
        $container.append(tr);

	    $.ajaxDefaultQ({
        	url: this.collection.url + "/" + venueId,
        	type: 'GET',
        }).done(function(response, status, xhr){
        	if(status == "success")
        	{
        	    if(response.data.length > 0) {
        	        $container.empty();
        		    for(var i=0; i<response.data.length; i++) {
                        var tableRow = response.data[i];
         		        $container.append(self.tableRowPartialTemplate(tableRow));
        		    }
        		} else
        		    $container.text(i18n.t('users.no_users'));
        	}else {
        	    console.error("Error while getting users for Venue ("+ venueId +")");
        	}
        })
        .fail(function(response) {
            console.error("Error while getting users for Venue ("+ venueId +")", response);
        });
	},
	logoutSpecificUser: function(e) {
	    const self = this;
	    const $elem = $(e.currentTarget);
	    const userId = $elem.data("id");

        const $container = $elem.parent().parent().parent();
        $container.empty();

        var tr = $("<tr/>");
        tr.css("display", "block");
        tr.html(self.progressTemplate());
        $container.append(tr);

        $.when(window.ping()).then(function(resp) {
            $.ajaxDefaultQ({
                url: "rest/api/admin/logins/out/" + userId,
                type: 'DELETE',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            }).done(function(response, status, xhr){
                if(status == "success")
                {
                    if(response.data.value == true)
                        $.notify(i18n.t("user.logoutUserSuccess"), { position:"top center", className: "success"});
                    else
                        $.notify(i18n.t("user.logoutUserError"), { position:"top center", className: "error"});
                }else {
                    $.notify(i18n.t("user.logoutUserError"), { position:"top center", className: "error"});
                }

                $($container.parent().parent().parent().find(".venueAccordion")[0]).trigger("click").trigger("click");
            })
            .fail(function(response) {
                console.error("Error while forcing logout for user ("+ userId +")", response);
                $.notify(i18n.t("user.logoutUserError"), { position:"top center", className: "error"});

                $($container.parent().parent().parent().find(".venueAccordion")[0]).trigger("click").trigger("click");
            });
        });


	}
});

